import React, { useState, useEffect } from 'react'

import { Stack, styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useSidebarContext } from '../../contexts/Old_SidebarContext'
import { useAuthContext } from '../../contexts/AuthContext'
import { DRAWER_WIDTH } from '../ChatBoat/constants'

import Sidebar from '../ChatBoat/LeftSidebar/Actions/Sidebar'

import NewMessage from '../ChatBoat/MainContent/NewMessage'

import SendMessage from '../ChatBoat/MainContent/SendMessage'

import Stepper from '../ChatBoat/MainContent/Messages/Actions/Stepper'
import baseUrl from '../../config/baseUrl'

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: any
}>(({ theme, open }) => ({
  display: 'flex',
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  padding: theme.spacing(2, 4, 2, 2),
  marginLeft: `-${DRAWER_WIDTH}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: theme.spacing(2),
  }),
}))

const MainContent = () => {
  const {
    setSelectedTab,

    sidebarOpen,
    allHistory,
    aiStorage,
    setAiStorage,
    setInputMessage,
    setAnswer,
    // setIsThreadIdDelete,
    // isThredIdDelete,
  } = useSidebarContext()

  const navigate = useNavigate()
  const token = sessionStorage.getItem('token')
  const userId = sessionStorage.getItem('userId')
  const { setAuthenticated } = useAuthContext()
  const [mergedData, setMergedData] = useState<any>([])
  const [subSearchActiveSteps, setSubSearchActiveSteps] = useState<any>(allHistory.map(() => 0))

  useEffect(() => {
    document.title = 'New Chat - Lawttorney'

    setSelectedTab(1)
    // Make initial API request when storedNumber changes
    if (userId !== null) {
      fetchData(userId)
    }

    // Set up an interval to call fetchData every 1 minute
    const intervalId = setInterval(() => {
      if (userId !== null) {
        fetchData(userId)
        // checkToken(userId)
      }
    }, 60000) // 60000 milliseconds = 1 minute

    // Clean up the interval when the component is unmounted
    return () => {
      clearInterval(intervalId)
    }
  }, [userId])

  // For Pagination :

  // useEffect(() => {
  //   const newArray = allHistory.map((obj: any) => {
  //     if (obj.subSerach) {
  //       return {
  //         ...obj,
  //         subSerach: [obj, ...obj.subSerach], // Move the object into subSerach
  //       }
  //     } else {
  //       return obj
  //     }
  //   })

  //   setMergedData(newArray)
  // }, [allHistory])

  // // Updated code for pagination 3

  // useEffect(() => {
  //   setSubSearchActiveSteps(allHistory.map(() => 0))
  // }, [allHistory])

  // const checkToken = async (userId: any) => {
  //   try {
  //     const response = await fetch(`${baseUrl}/api/logintoken/chectoken`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         userid: userId,
  //         token,
  //       }),
  //     })

  //     if (!response.ok) {
  //       throw Error(`${response.statusText} - ${response.url}`)
  //     }

  //     const data = await response.json()
  //     // console.log('data checktoken', data)
  //     if (data.status === false) {
  //       sessionStorage.clear()
  //       // localStorage.clear()
  //       setAuthenticated(false)
  //       navigate('/auth/login', { replace: true })
  //     }
  //   } catch (error) {
  //     console.error('Error during API request:', error)
  //   }
  // }
  
  const fetchData = async (userId: number | string) => {
    try {
      const response = await fetch(`${baseUrl}/api/admin/userstatus/${userId}`)

      if (response.ok) {
        const data = await response.json()

        if (data.Blocked === true) {
          // localStorage.clear()

          navigate('/auth/login')
        }
        // Process the data as needed
      } else {
        console.error('API request failed')
      }
    } catch (error) {
      console.error('Error during API request:', error)
    }
  }

  const handleSubSearchStepChange = (index: number, step: number) => {
    setSubSearchActiveSteps((prevActiveSteps: any) => {
      const newActiveSteps = [...prevActiveSteps]
      newActiveSteps[index] = step
      return newActiveSteps
    })
  }

  return (
    <Main style={{ position: 'relative', marginTop: '5.5rem' }} open={sidebarOpen}>
      {!sidebarOpen && <Sidebar />}
      <Stack flexGrow={1} alignItems='center' position='relative'>
        <Stack flexGrow={1} spacing={2} width={1} maxWidth={1000}>
          <Stack flexGrow={1} spacing={2}>
            {/* <ActiveFilters /> */}
            {mergedData?.length === 0 && <NewMessage />}

            {mergedData?.map((each: any, eachIndex: number) => (
              <div key={each.id}>
                <Stepper
                  subSearchArray={each.subSerach || []}
                  activeStep={subSearchActiveSteps[eachIndex]}
                  handleStepChange={(step: number) => {
                    handleSubSearchStepChange(eachIndex, step)
                  }}
                />
              </div>
            ))}
          </Stack>
          <div style={{ position: 'relative' }}>
            {!mergedData?.length && (
              <p>
                The provided information outlines the required experience, skill sets, and
                responsibilities for a position related to designing and delivering UI solutions for
                network operational processes. Below is a breakdown of the qualifications and skills
                needed for this role..:
              </p>
            )}
          </div>
          <SendMessage
            setInputMessage={setInputMessage}
            setAnswer={setAnswer}
            aiStorage={aiStorage}
            setAiStorage={setAiStorage}
          />
        </Stack>
      </Stack>
    </Main>
  )
}

export default MainContent
